module.exports = __webpack_public_path__ + "static/img/ic-coupon.dd1414ac.jpg";